import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=fb9b3088"
import script from "./videoComponent.vue?vue&type=script&lang=js"
export * from "./videoComponent.vue?vue&type=script&lang=js"
import style0 from "./videoComponent.vue?vue&type=style&index=0&id=fb9b3088&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports